<template>
  <div class="volunteer-actions">
    <ag-table :data-source-api="getAllVolunteerActions" :grid-options="gridOptions" :permissions="permissions"
      :rtl="false" :is-entities-response="false" />
    <tm-popup title="صور المشاركات" ref="volunteerActionsPopup">
      <div class="volunteer-actions-popup-content">
        <div v-for="(image, i) in volunteerImageLinks" :key="i">
          <img :src="image">
        </div>
      </div>
    </tm-popup>
    <tm-popup :submit="onRemoveSharePopupSubmit" title="التراجع عن المشاركة" ref="removeSharePopup">
      <div class="vx-row justify-start">
        <div class="vx-col w-full mb-2 mt-2">
          <tm-select class="w-full" :options="coupons" label="name" validation-rules="required" name="الكوبون"
            :reduce="name => name.code" v-model="shareEntity.couponCode" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import { RepositoryFactory } from '../../zadi/zadi-repositories/zadiRepositoryFactory';
import { RepositoryFactory as LoyaltyRepositoryFactory } from '@/app/loyalty-system/loyalty-repositories/loyaltyRepositoryFactory';
import AgTable from '../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import AgTableBtnCell from "../../shared/shared-components/ag-grid/AgTableBtnCell";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import AgButton from "@/app/shared/shared-components/ag-grid/AgButton";
import TmSelect from "@/app/shared/shared-components/TmSelect";

const couponsRepo = LoyaltyRepositoryFactory.get('couponsRepository');
const zadiRepo = RepositoryFactory.get('zadiRepository');

export default {
  name: "VolunteerActions",
  components: {
    AgTable,
    AgTableBtnCell,
    TmPopup,
    AgButton,
    TmSelect
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      permissions: {},
      volunteerImageLinks: [],
      coupons: [],
      shareEntity: {
        couponCode: null,
        shareEntityId: null
      },
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'نوع المشاركة',
          field: 'entityType',
          // filter: 'agTextColumnFilter',
          width: 200,
          sortable: false,
          valueGetter:
            function getObject(params) {
              return self.getEntityType(params.data);
            },
        },
        {
          headerName: 'عدد المشاركات',
          field: 'totalCount',
          // filter: 'agNumberColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'التراجع عن المشاركة',
          field: 'entityId',
          width: 210,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter:
            function getObject(params) {
              return params.data;
            },
          cellRendererParams: () => {
            return {
              size: 'small',
              color: 'primary',
              name: 'التراجع عن المشاركة',
              type: 'gradient',
              click(row) {
                self.onRemoveShare(row);
              }
            };
          },
        },
        {
          headerName: 'الإجراءات',
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          cellRendererParams: {
            viewRecordDetails: function (action) {
              self.onShowImages(action);
            },
            actions: ['view'],
            permissions: self.permissions
          },
        }
      ];
    },
    async getAllVolunteerActions(query) {
      const id = this.$route.params.id;
      return await zadiRepo.fetchVolunteerSharing(query, id);
    },
    onShowImages(action) {
      this.$refs.volunteerActionsPopup.open();
      this.volunteerImageLinks = action.imageLinks;
    },
    onRemoveShare(entity) {
      this.$refs.removeSharePopup.open();
      this.shareEntity = {
        couponCode: null,
        shareEntityId: entity.id,
      };
    },
    async onRemoveSharePopupSubmit() {
      try {
        await zadiRepo.removeShare(this.shareEntity);
        this.$refs.removeSharePopup.close();
        await this.gridApi.refreshServerSideStore({ purge: true });
      } catch (err) {
        this.$refs.removeSharePopup.endLoading();
      }
    },
    getEntityType(row) {
      if (row.entityType == 'BOOK') return `ملخص ${row.entityDetails.title}`;
      if (row.entityType == 'MAGAZINE') return `مجلة زادي عدد ${row.entityDetails.releaseNumber}`;
      if (row.entityType == 'FACEBOOK_PAGE') return `صفحة الفيسبوك`;
    },
    async getAllCoupons() {
      const data = await couponsRepo.fetchCoupons('?filter=points||$lt||0');
      this.coupons = data.data;
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.getAllCoupons();
    this.gridApi = this.gridOptions.api;
  }
};
</script>

<style scoped>
.volunteer-actions-popup-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.volunteer-actions-popup-content img {
  max-width: 250px;
  width: 100%;
  border-radius: 8px;
}
</style>
